import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { useFieldFormContext } from "@/features/question/components/organisms/FieldForm";
import { PickGroupRankOptions } from "@/types/crm/tables/question";
import { useEffect, useState } from "react";

export function PickGroupRankForm() {
    const { isFormDisabled, form } = useFieldFormContext();
    const [option, setOption] = useState<string>("");
    const [group, setGroup] = useState<string>("");
    const fieldOptions = form?.watch('field_options') as PickGroupRankOptions | undefined;
    function onSubmitOption(e: React.FormEvent<HTMLButtonElement>) {
        e.preventDefault();
        setOption("");
        form?.setValue('field_options', { groups: [...(fieldOptions.groups ?? [])], options: [...(fieldOptions.options ?? []), option] });
    }
    function onSubmitGroup(e: React.FormEvent<HTMLButtonElement>) {
        e.preventDefault();
        setGroup("");
        form?.setValue('field_options', { groups: [...(fieldOptions.groups ?? []), group], options: [...(fieldOptions.options ?? [])] });
    }
    useEffect(() => {
        setOption("");
    }, [])

    return (
        <Tabs className="w-full" defaultValue="options">
            <TabsList className="grid w-full grid-cols-2">
                <TabsTrigger value="options" className="w-full">Options</TabsTrigger>
                <TabsTrigger value="groups" className="w-full">Groups</TabsTrigger>
            </TabsList>
            <TabsContent value="options">
                <div className="flex flex-col gap-2">
                    <div>
                        <p className="mb-2 text-sm font-medium">Add Option</p>
                        <div className="flex gap-2">
                            <Input
                                onChange={(e: React.ChangeEvent<HTMLInputElement>) => setOption(e.target.value)}
                                type='text'
                                value={option}
                                disabled={isFormDisabled}
                                autoComplete="off"
                            />
                            <Button type="button" onClick={onSubmitOption} disabled={isFormDisabled || !option || fieldOptions?.options?.includes(option)}>Add</Button>
                            {fieldOptions?.options?.includes(option) && (
                                <p className="text-red-500">Option already exists</p>
                            )}
                        </div>
                    </div>

                    <p className="font-medium">Options</p>

                    <div className="flex flex-col gap-1">
                        {fieldOptions?.options?.map((option) => (
                            <div key={option} className="flex justify-between p-2 border rounded-md">
                                <p>{option}</p>
                                <div className="">
                                    {!isFormDisabled && (
                                        <i className="bi bi-trash" onClick={() => {
                                            form?.setValue('field_options', field_options.filter(o => o !== option))
                                        }}></i>
                                    )}
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </TabsContent>
            <TabsContent value="groups">
                <div className="flex flex-col gap-2">
                    <div>
                        <p className="mb-2 text-sm font-medium">Add Group</p>
                        <div className="flex gap-2">
                            <Input
                                onChange={(e: React.ChangeEvent<HTMLInputElement>) => setGroup(e.target.value)}
                                type='text'
                                value={group}
                                disabled={isFormDisabled}
                                autoComplete="off"
                            />
                            <Button type="button" onClick={onSubmitGroup} disabled={isFormDisabled || !group || fieldOptions?.groups?.includes(group)}>Add</Button>
                            {fieldOptions?.groups?.includes(group) && (
                                <p className="text-red-500">Group already exists</p>
                            )}
                        </div>
                    </div>

                    <p className="font-medium">Groups</p>

                    <div className="flex flex-col gap-1">
                        {fieldOptions?.groups?.map((group) => (
                            <div key={group} className="flex justify-between p-2 border rounded-md">
                                <p>{group}</p>
                                <div className="">
                                    {!isFormDisabled && (
                                        <i className="bi bi-trash" onClick={() => {
                                            form?.setValue('field_options', { groups: fieldOptions.groups.filter(g => g !== group), options: fieldOptions.options })
                                        }}></i>
                                    )}
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </TabsContent>
        </Tabs>
    )
}